import React, { useEffect } from "react";
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Form,
  Row,
  Col,
  Input,
  Button,
  FormGroup
} from "reactstrap";

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// services
import { showMessage, showQuestion } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

import { useAuth } from "context/auth.js";

export default function CadastroModeloCertidao({ history }) {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

  const [permiteEditar, set_permiteEditar] = React.useState(false);

  const [status, set_status] = React.useState("");
  const [options_status] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  }

  const [rowEdit, set_rowEdit] = React.useState(null);
  const [openCollapse, set_openCollapse] = React.useState(false);
  const [list_table, set_list_table] = React.useState([]);
  const [list_variaveis, set_list_variaveis] = React.useState([]);

  const loadList = () => {
    set_openCollapse(false);
    set_rowEdit(null);
    setLoading(true);
    api_GET('ModeloCertidao')
      .then(result => set_list_table(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  const loadVariaveis = () => {
    api_GET('ModeloCertidao/GetVariaveis')
      .then(result => set_list_variaveis(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null));
  }

  const handleAdd = () => {
    set_rowEdit(null);
    setValue("descricao", "");
    setValue("sigla", "");
    setValue("textoCertidao", "");
    setValue("status", "", false);
    set_status("");
    set_openCollapse(true);
  }

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    setValue("descricao", rowData.descricao);
    setValue("sigla", rowData.sigla);
    setValue("textoCertidao", rowData.textoCertidao);
    handleStatus(rowData.status);
    setValue("status", rowData.status, false);
    set_openCollapse(true);
  }

  const handleDelete = (rowData) => {
    showQuestion("Aviso", "Tem certeza que quer deletar o registro?", 'question', function (retorno) {
      if (retorno) {
        setLoading(true);
        api_POST('ModeloCertidao/Delete', rowData)
          .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
          .catch(err => showMessage("Aviso", err.message, 'error', null))
          .finally(() => setLoading(false));
      }
    });
  }

  // Insere o placeholder da variável na posição do cursor (ou no final, se não houver foco)
  const handleInsereVariavel = (variavel) => {
    let texto = getValues("textoCertidao") || "";
    let campo = document.getElementsByName("textoCertidao")[0];
    let posicao = campo != null && campo.selectionStart != null
      ? campo.selectionStart
      : texto.length;

    let novoTexto =
      texto.substring(0, posicao) + variavel.placeholder + texto.substring(posicao);

    setValue("textoCertidao", novoTexto);

    if (campo != null) {
      campo.focus();
      campo.setSelectionRange(
        posicao + variavel.placeholder.length,
        posicao + variavel.placeholder.length
      );
    }
  }

  const onSubmit = (data) => {

    let json_submit = {
      modeloCertidao_Id: rowEdit != null ? rowEdit.modeloCertidao_Id : 0,
      descricao: data.descricao,
      sigla: data.sigla,
      status: status,
      textoCertidao: data.textoCertidao,
      usuarioCadastro_Id: session.usuario_Id,
      usuarioUltimaAlteracao_Id: session.usuario_Id
    }

    setLoading(true);
    if (json_submit.modeloCertidao_Id == 0) {
      api_POST('ModeloCertidao', json_submit)
        .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false));
    }
    else {
      api_PUT('ModeloCertidao', json_submit)
        .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false));
    }
  }

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("ModeloCertidao.Editar", function (result) { set_permiteEditar(result) });
    loadVariaveis();
    loadList();
  }, []);

  return (
    <>
      <div className="content">
        <button type="button" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Novo Modelo de Certidão</button>
        <Collapse isOpen={openCollapse} defaultOpen={false}>
          <Row>
            <Col md="12">
              <Card className="card-user">
                <CardHeader>
                  <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                </CardHeader>
                <CardBody style={{ minHeight: "auto" }}>
                  <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md="8" sm="12">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Descrição</label></b>
                          <Input type="text" name="descricao" maxLength={100} innerRef={register({ required: true })} />
                          {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="2" sm="6">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Sigla</label></b>
                          <Input type="text" name="sigla" maxLength={10} innerRef={register({ required: true })} />
                          {errors.sigla && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="2" sm="6">
                        <FormGroup>
                          <b><label><span className="text-danger">*</span> Status</label></b>
                          <Select
                            options={options_status}
                            name="status"
                            getOptionLabel={({ label }) => label}
                            getOptionValue={({ value }) => value}
                            onChange={(e) => { handleStatus(e.value) }}
                            value={status != "" && options_status.find(obj => obj.value === status)}
                            placeholder="Selecione"
                            ref={e => register(
                              { name: "status" },
                              { required: true })
                            }
                          />
                          {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="12" sm="12">
                        <FormGroup>
                          <b><label> Texto da Certidão</label></b>
                          <Input type="textarea" name="textoCertidao" rows={12} maxLength={8000} innerRef={register({ required: false })} />
                        </FormGroup>
                      </Col>
                      <Col md="12" sm="12">
                        <FormGroup>
                          <b><label> Variáveis disponíveis</label></b>
                          <div>
                            <small className="text-muted">Clique na variável para inserir no texto da certidão.</small>
                          </div>
                          <div style={{ marginTop: "8px" }}>
                            {list_variaveis.map((variavel) => (
                              <Button
                                key={variavel.chave}
                                type="button"
                                color="info"
                                size="sm"
                                style={{ marginRight: "6px", marginBottom: "6px" }}
                                onClick={() => handleInsereVariavel(variavel)}
                              >
                                {variavel.descricao}
                              </Button>
                            ))}
                          </div>
                        </FormGroup>
                      </Col>
                      <Col className="text-center" md="12" sm="12">
                        <FormGroup>
                          <Button disabled={!permiteEditar} color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Collapse>
        <Row>
          <Col md="12">
            <MaterialTable style={{ minHeight: "auto" }}
              title=""
              columns={[
                { title: 'Descrição', field: 'descricao' },
                { title: 'Sigla', field: 'sigla' },
                { title: 'Status', field: 'status' },
              ]}
              data={list_table}
              isLoading={false}
              options={{
                ...table_style,
                filtering: false,
                exportButton: true
              }}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Editar Registro',
                  onClick: (event, rowData) => handleEdit(rowData)
                },
                {
                  icon: 'delete',
                  tooltip: 'Excluir Registro',
                  onClick: (event, rowData) => handleDelete(rowData)
                }
              ]}
              localization={table_translate}
            />
          </Col>
        </Row>
      </div>
    </>
  );

}
